<template>
    <svg
        ref="waveCluster"
        class="absolute inset-0 w-full h-full text-ocean-500"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
    >
        <path class="text-ocean-500 fill-current"></path>
        <path class="text-ocean-700 fill-current"></path>
        <path class="text-ocean-800 fill-current"></path>
        <path class="text-ocean-900 fill-current"></path>
    </svg>
</template>

<script>
export default {
    data() {
        return {
            wave: '',
            numPoints: 4,
            duration: 800,
            delayPointsArray: [],
            delayPointsMax: 180,
            delayPerPath: 70,
            timeStart: Date.now(),
            isReady: false,
            isAnimating: false
        };
    },

    mounted() {
        this.wave = this.$refs.waveCluster.querySelectorAll('path');
    },

    methods: {
        // π ----
        // :: ACTIONS ---------------------------::
        // ____
        toggle() {
            this.isAnimating = true;
            const range = Math.random() * Math.PI * 2;
            for (let i = 0; i < this.numPoints; i++) {
                const radian = (i / (this.numPoints - 1)) * Math.PI * 2;
                this.delayPointsArray[i] = ((Math.sin(radian + range) + 1) / 2) * this.delayPointsMax;
            }
            if (this.isReady === false) {
                this.open();
            } else {
                this.close();
            }
        },

        open() {
            this.isReady = true;
            this.timeStart = Date.now();
            this.renderLoop();
        },

        close() {
            this.isReady = false;
            this.timeStart = Date.now();
            this.renderLoop();
        },

        // π ----
        // :: UTILITIES ---------------------------::
        // ____
        updatePath(time) {
            const points = [];
            for (let i = 0; i < this.numPoints; i++) {
                points[i] = this.ease(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1)) * 100;
            }

            let str = '';
            str += this.isReady ? `M 0 0 V ${points[0]} ` : `M 0 ${points[0]} `;
            for (let i = 0; i < this.numPoints - 1; i++) {
                const p = ((i + 1) / (this.numPoints - 1)) * 100;
                const cp = p - ((1 / (this.numPoints - 1)) * 100) / 2;
                str += `C ${cp} ${points[i]} ${cp} ${points[i + 1]} ${p} ${points[i + 1]} `;
            }
            str += this.isReady ? `V 0 H 0` : `V 100 H 0`;
            return str;
        },

        ease(t) {
            return t < 0.5 ? 4.0 * t * t * t : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
        },

        render() {
            if (this.isReady) {
                for (let i = 0; i < this.wave.length; i++) {
                    this.wave[i].setAttribute(
                        'd',
                        this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * i))
                    );
                }
            } else {
                for (let i = 0; i < this.wave.length; i++) {
                    this.wave[i].setAttribute(
                        'd',
                        this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * (this.wave.length - i - 1)))
                    );
                }
            }
        },

        renderLoop() {
            this.render();
            if (
                Date.now() - this.timeStart <
                this.duration + this.delayPerPath * (this.wave.length - 1) + this.delayPointsMax
            ) {
                requestAnimationFrame(() => {
                    this.renderLoop();
                });
            } else {
                this.isAnimating = false;

                this.$emit('animated-in', true);
            }
        }
    }
};
</script>
